import { FC } from 'react'
import styles from '../../styles/admin/StudyContent.module.scss'
import SignInInput from '../common/SignInInput'

interface QuestionInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  className?: string
  label?: string
}

const QuestionInput: FC<QuestionInputProps> = ({
  value,
  onChange,
  placeholder = '문제를 입력하세요...',
  className,
  label = '문제입력',
}) => {
  return (
    <div className={styles.questionInputContainer}>
      <div className={styles.questionInputWrapper}>
        <span className={styles.questionInputLabel}>{label}</span>
        <SignInInput
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className={className || styles.questionInput}
        />
      </div>
    </div>
  )
}

export default QuestionInput
